import '.a2{position:fixed;}.ssr-plugin'
import '.ch{top:0;}.ssr-plugin'
import '.bl{left:0px;}.ssr-plugin'
import '.bm{right:0px;}.ssr-plugin'
import '.ed{bottom:0px;}.ssr-plugin'
import '.h1{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.h2{z-index:998;}.ssr-plugin'
import '.h3{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a9{height:100vh;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.h4{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h5{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.y{justify-content:space-between;}.ssr-plugin'
import '.c1{padding:1.5rem;}.ssr-plugin'
import '.h6{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bq{flex-shrink:0;}.ssr-plugin'
import '.c6{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a2 ch bl bm ed h1 h2 h3"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a2 ch a9 x ac h4 h5 a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c y c1 h6 bq"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c6 ar c1"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
